<script lang="ts" setup>
import { RouterView } from 'vue-router';
import { PageHeader } from '../components/page-header';
import { PageFooter } from '../components/page-footer';
import { Sidebar } from '../components/sidebar';

defineOptions({
  name: 'LayoutSettings',
});
</script>

<template>
  <div class="min-h-screen flex flex-col pt-16">
    <PageHeader />

    <div class="flex-1">
      <div class="mx-auto max-w-7xl flex flex-1 py-8 px-4 gap-x-4">
        <aside class="hidden md:block">
          <Sidebar />
        </aside>
        <main class="min-w-0 flex-1 py-6">
          <RouterView v-slot="{ Component, route }">
            <Component :is="Component" :key="route.name || route.path" v-if="route.meta.ignoreCache" />
          </RouterView>
          <RouterView v-slot="{ Component, route }">
            <KeepAlive max="20">
              <Component :is="Component" :key="route.name || route.path" v-if="!route.meta.ignoreCache" />
            </KeepAlive>
          </RouterView>
        </main>
      </div>
    </div>

    <PageFooter />
  </div>
</template>

<style lang="scss" scoped>
</style>
